import { apiPost } from '@/shared/utils/requestBuilder';

export type DocumentoFonte = 'database' | 'api';

/**
 * Resultado do lookup de documento no endpoint compartilhado de integrações
 * (`POST /integracoes/cpf-cnpj/validar`). É o MESMO endpoint/retorno usado hoje
 * pelas telas de Notificação e Negociação — aqui ele fica centralizado em
 * `src/shared` para evitar reimplementar service/thunk/estado em cada feature.
 */
export interface DocumentoLookupResult {
  tipo?: string;
  documento?: string;
  nome: string;
  fonte?: DocumentoFonte;
  logradouro?: string;
  numero?: string;
  complemento?: string;
  bairro?: string;
  cidade?: string;
  uf?: string;
  cep?: string;
}

export const documentoLookupService = {
  validar: async (documento: string): Promise<DocumentoLookupResult> => {
    const response = await apiPost('/integracoes/cpf-cnpj/validar', { documento });
    if (!response.ok) {
      const errorData = await response.json().catch(() => null);
      const message =
        (typeof errorData?.error === 'string' && errorData.error) ||
        errorData?.error?.message ||
        errorData?.message ||
        'Erro ao validar CPF/CNPJ';
      throw new Error(message);
    }
    const result = await response.json();
    return (result?.data ?? result) as DocumentoLookupResult;
  },
};
